import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ProductionWorkflowOwnerReassignDto } from "../../../core/models/project-workflow/productionWorkflowOwnerReassignDto";
import { ProductionWorkflowReassignLogDto } from "../../../core/models/project-workflow/productionWorkflowReassignLogDto";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { ProjectWorkflowReAssignStatus } from "../../../shared/enums/projectWorkflowReAssignStatus";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-reassign-workflow-approval",
  templateUrl: "./reassign-workflow-approval.component.html",
  styleUrls: ["./reassign-workflow-approval.component.scss"],
  imports: [CommonModule],
})
export class ReassignWorkflowApprovalComponent implements OnInit {
  workflowId = 0;
  newOwner = "";
  previousOwner = "";
  paddedWorkflowId = "";
  logs: ProductionWorkflowReassignLogDto[] = [];

  constructor(
    private route: ActivatedRoute,
    private _loaderService: LoaderService,
    private _workflowService: ProjectWorkflowService,
    private _toastr: JniToastrService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.workflowId = +this.route.snapshot.paramMap.get("workflowId")!;
    this.newOwner = this.route.snapshot.paramMap.get("newOwner")!;
    this.paddedWorkflowId = this.workflowId.toString().padStart(6, "0");

    if (this.workflowId) {
      this.getReassignedWorkflowLogs();
    }
  }

  getReassignedWorkflowLogs() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getReassignedWorkflowLogs(this.workflowId).subscribe({
      next: res => {
        if (res?.status === "Success" && res?.data) {
          this.logs = res.data.filter(
            x => x.requestStatus == ProjectWorkflowReAssignStatus.Pending
          );
          this.previousOwner =
            this.logs[this.logs.length - 1].workflowOwnerName;
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  handleApproval(status: number) {
    const log = this.logs[this.logs.length - 1];
    const payload: ProductionWorkflowOwnerReassignDto = {
      projectWorkflowId: this.workflowId,
      previousWorkflowOwner: log.workFlowOwnerId,
      newWorkflowOwner: this.newOwner,
      reason: log.reason,
      requestStatus: status,
      logId: log.logId,
    };

    this._loaderService.setLoaderState(true);
    this._workflowService.reassignWorkflow(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);

        if (res?.status?.toLowerCase() === "success") {
          this._toastr.success(
            "Success",
            res.message || "workflow submitted successfully"
          );
          this._router.navigate(["production-workflow"]);
        } else {
          this._toastr.error(
            "Error",
            res.message || "Error submitting workflow"
          );
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }
}
